import React from 'react';

import Card from '../card';

export default function StudentInfo({ t, studentInfo = {} }) {
  const studentInfoFields = [
    {
      label: t('landlord.booking.reconciliation.details.name.label'),
      value: `${studentInfo?.passportFirstName} ${studentInfo?.passportMiddleName ?? ''} ${
        studentInfo?.passportLastName
      }`,
    },
    {
      label: t('landlord.booking.reconciliation.details.email_address.label'),
      value: studentInfo.emailAddress,
    },
    {
      label: t('landlord.booking.reconciliation.details.phone_number.label'),
      value: studentInfo.phoneNumber,
    },
  ];

  return (
    <Card
      title={t('landlord.booking.reconciliation.details.student_info.title')}
      dataSet={studentInfoFields}
    />
  );
}
